import {Icon} from '@ezcater/tapas';
import {faFacebook, faInstagram, faLinkedin, faYoutube} from '@fortawesome/free-brands-svg-icons';

import {gtm} from '@/utils';

type SocialLinksProps = {
  className?: string;
};

const trackGTMEvent = (href: string) => {
  gtm.dataLayer({
    event: 'social_profile_click',
    click_destination: href,
  });
};

const SocialLinks: React.FC<SocialLinksProps> = ({className}) => (
  <div
    className={
      className ||
      'flex justify-center gap-3 pt-4 text-[1.4rem] [&_a]:inline-block [&_a]:text-peppercorn-800'
    }
  >
    <a
      href="https://www.linkedin.com/company/ezcater"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="linkedin"
      onClick={() => trackGTMEvent('https://www.linkedin.com/company/ezcater')}
    >
      <Icon icon={faLinkedin} size="medium" className="rounded-md" />
    </a>
    <a
      href="https://www.facebook.com/pages/ezCater/157973357563522"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="facebook"
      onClick={() => trackGTMEvent('https://www.facebook.com/pages/ezCater/157973357563522')}
    >
      <Icon icon={faFacebook} size="medium" />
    </a>
    <a
      href="https://www.youtube.com/@ezCater"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="youtube"
      onClick={() => trackGTMEvent('https://www.youtube.com/@ezCater')}
    >
      <Icon icon={faYoutube} size="medium" />
    </a>
    <a
      href="https://www.instagram.com/ezcater/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="instagram"
      onClick={() => trackGTMEvent('https://www.instagram.com/ezcater/')}
    >
      <Icon icon={faInstagram} size="medium" />
    </a>
  </div>
);

export default SocialLinks;
